<template>
  <div v-show="items.length > 0" class="carousel">
    <transition-group tag="ul" name="list">
      <li v-for="item in items" :key="item.createdAt">
        <div class="avatar">
          <webp-image :src="item.avatar" alt="avatar" width="100%" height="100%" />
        </div>
        <div class="content">
          <span class="name">{{ item.nick }}</span>捐赠 {{ duration2course(item.duration) }} 节课程
        </div>
        <div class="time">{{ formatTime(item.createdAt) }}</div>
      </li>
    </transition-group>
  </div>
</template>

<script>
  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'carousel',
    data () {
      return {
        items: []
      }
    },
    computed: {
      donations () {
        return this.$store.state.user.donations
      },
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      }
    },
    created () {
      setInterval(() => {
        if (this.items.length > 0) {
          const tmpArray = [...this.items]
          tmpArray.push(tmpArray.shift())
          this.items = tmpArray
        }
      }, 3000)
    },
    methods: {
      duration2course (duration) {
        return Math.floor(duration / this.basicDonateDuration)
      },
      formatTime (beforeTime) {
        const time = (new Date().getTime() - beforeTime * 1000) / 1000
        if (time < 60) {
          return `${Math.floor(time) + 1}秒前`
        } else if (time < 3600) {
          return `${Math.floor(time / 60) + 1}分钟前`
        } else {
          return `${Math.floor(time / 3600) + 1}小时前`
        }
      }
    },
    watch: {
      donations (val) {
        this.items = val
      }
    },
    components: {
      WebpImage
    }
  }
</script>

<style lang="scss" scoped>
  @import '../assets/scss/vars';

  .carousel {
    @include border-radius;
    width: 100%;
    height: 88px;
    overflow: hidden;
    background-color: $grey;
    ul {
      @include border-radius;
      margin-top: -88px;
    }
    li {
      display: flex;
      height: 48px;
      padding: 20px;
      font-size: 28px;
      color: $black;
      &:last-child {
        visibility: hidden;
      }
    }
    .avatar {
      width: 48px;
      height: 48px;
      line-height: 88px;
      font-size: 0;
      img {
        border-radius: 50%;
      }
    }
    .content {
      flex: 1;
      margin-left: 20px;
      font-size: 28px;
      line-height: 48px;
      span.name {
        margin-right: 10px;
        color: $darkRed;
      }
    }
    .time {
      font-size: 24px;
      color: rgba($black, 0.54);
      line-height: 48px;
    }
  }
  .list-move {
    transition: transform 1s;
  }
</style>



// WEBPACK FOOTER //
// Carousel.vue?ac0c6074